// ABOUTME: Footer of the bulk change steps: a divider, then the step buttons centred below the content.
// ABOUTME: Shared by the Scope, Actions, Preview and Result steps so every step ends the same way.

import { Divider, Stack } from '@ds/coolshop';
import { ReactNode } from 'react';

export function StepFooter({ children }: { children: ReactNode }) {
    return (
        <>
            <Divider />
            <Stack
                direction="row"
                gap={1}
                justifyContent="center"
                alignItems="center"
                px={1}
                py={3}
            >
                {children}
            </Stack>
        </>
    );
}
